import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { EducationalContentEntity } from '../../models/educational-content.entities';
import * as EducationalContentPageActions from '../actions/educational-content.actions';

export const EDUCATIONAL_PAGE_FEATURE_KEY = 'aemContent';

export interface State extends EntityState<EducationalContentEntity> {
  loaded: boolean; // has the SkyMiles list been loaded
  error?: string | null; // last known error (if any)
}

export const educationalContentAdapter: EntityAdapter<EducationalContentEntity> =
  createEntityAdapter<EducationalContentEntity>();

export const initialState: State = educationalContentAdapter.getInitialState({
  loaded: false
});

const educationalContentPageReducer = createReducer(
  initialState,
  on(
    EducationalContentPageActions.loadAEMContentSuccess,
    (state, { aemContent }) =>
      educationalContentAdapter.setOne(aemContent, {
        ...state,
        loaded: true
      })
  ),
  on(
    EducationalContentPageActions.loadAEMContentFailure,
    (state, { aemContentError }) =>
      educationalContentAdapter.setOne(aemContentError, {
        ...state,
        loaded: true,
        error: aemContentError.aemContentError
      })
  )
);

export const reducer = (state: State | undefined, action: Action) =>
  educationalContentPageReducer(state, action);
